export default __webpack_public_path__ + "static/argentina-ecbbf6812e0e6481a0fc3700c5f538fc.jpg";